import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const ReferenceImageWrapper = styled.div<{
  $hoverText: string
}>`
  width: 100%;
  height: 100%;
  position: relative;

  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};

  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;
  cursor: pointer;

  &::after {
    transition: opacity 0.2s ease-in-out;
    opacity: 0;
    content: '${({ $hoverText }) => $hoverText}';
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(53, 62, 90, 0.7);

    display: flex;
    align-items: center;
    justify-content: center;

    color: ${COLORS.white};
    font-size: ${({ $hoverText }) =>
      $hoverText.length > 10 ? '11px' : '14px'};
    font-weight: 500;
    text-align: center;
  }

  &:hover {
    &:after {
      opacity: 1;
    }
  }
`

export const ReferenceImage = styled.img<{
  $isLoading?: boolean
}>`
  object-fit: cover;
  max-width: 100%;
  max-height: 100%;

  opacity: ${({ $isLoading }) => ($isLoading ? 0 : 1)};
  transition: opacity 0.5s ease-in-out;
`
